// ═══════════════════════════════════════════════════════════════════
// TMS GAMMA — Carregamento da biblioteca de planilha
//
// Antes, o SheetJS vinha de um <script> em public/index.html apontando
// para cdn.sheetjs.com, SEM integrity e SEM crossorigin, executado em
// TODA carga de página — inclusive na tela de login, na mesma página que
// guarda a sessão do Supabase (#20).
//
// Três problemas de uma vez:
//   • cadeia de suprimento: código de terceiro com privilégio total na
//     página, e sem SRI o navegador aceitava qualquer conteúdo daquela URL;
//   • disponibilidade: CDN fora do ar = exportação quebrada, em silêncio;
//   • desempenho: script bloqueante de terceiro antes da primeira pintura.
//
// Agora a biblioteca é dependência declarada, com hash de integridade no
// package-lock, e entra por import dinâmico — só quando alguém realmente
// exporta ou importa planilha.
//
// POR QUE CONTINUA EM window.XLSX
//
// Cerca de 30 pontos, em 20 módulos, fazem `const XLSX = window.XLSX`
// dentro de funções que em boa parte não são async. Trocar todos por
// `await import` mudaria a assinatura delas e obrigaria os chamadores a
// lidar com promessa — refactor grande, em telas que eu não consigo
// abrir para conferir.
//
// O ponto de acesso continua o mesmo; o que muda é de onde o objeto vem.
// Migrar cada módulo para import direto segue possível depois, um por vez.
// ═══════════════════════════════════════════════════════════════════

/** Promessa em voo, para dois cliques simultâneos não baixarem duas vezes. */
let carregando = null;

/**
 * Garante que a biblioteca está disponível e devolve o módulo.
 *
 * Idempotente: se já estiver carregada, devolve na hora.
 */
export async function carregarXLSX() {
  if (typeof window !== "undefined" && window.XLSX) return window.XLSX;
  if (!carregando) {
    carregando = import("xlsx").then((mod) => {
      // O bundle expõe o namespace no default em alguns formatos.
      const lib = mod?.utils ? mod : mod?.default;
      if (typeof window !== "undefined") window.XLSX = lib;
      return lib;
    });
  }
  return carregando;
}

/**
 * Dispara o carregamento sem esperar. Chamado pelo App depois do login.
 *
 * A exportação é ação deliberada do usuário — ele clica e espera. Mas
 * carregar antes evita que o primeiro clique pague o download inteiro, que
 * é justamente quando a demora parece defeito.
 *
 * Falha em silêncio de propósito: sem rede, quem clicar em exportar recebe
 * o erro no lugar certo, e não um alerta no meio de outra tarefa.
 */
export function precarregarXLSX() {
  carregarXLSX().catch(() => {});
}
